import React from 'react';

import MagicWandIcon from '@atlaskit/icon/core/magic-wand';

export const ImproveWritingIcon = () => (
	<MagicWandIcon label="" color="currentColor" spacing="spacious" />
);
